import React from "react";
import AppBar from "../app-bar/app-bar";
import PharmacyDetails from "../data-tables-distributor/pharmacy/pharmacy-details";
import {useUser} from "../providers/user-context";

function PharmacyPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            <PharmacyDetails navOpen={navOpen} tenantType={tenantType}/>
        </div>
    );
}
export default PharmacyPage;
